
import { User } from '@supabase/supabase-js';
import { Profile } from '@/types/auth';

export function getUserDisplayName(user: User | null, profile: Profile | null): string {
  if (!user) return 'Guest';

  // Prefer profile names if present
  const profileFirst = profile?.first_name?.trim();
  const profileLast = profile?.last_name?.trim();
  if (profileFirst) {
    return profileLast ? `${profileFirst} ${profileLast}` : profileFirst;
  }

  // Fallback to auth user metadata
  const metaFirst = (user.user_metadata?.first_name as string | undefined)?.trim();
  const metaLast = (user.user_metadata?.last_name as string | undefined)?.trim();
  if (metaFirst) {
    return metaLast ? `${metaFirst} ${metaLast}` : metaFirst;
  }

  // Final fallback: email username
  return user.email ? user.email.split('@')[0] : 'User';
}

export function getUserAvatar(user: User | null, profile?: Profile | null): string | null {
  if (!user) return null;

  // OAuth providers (Google, GitHub, etc.) often expose an avatar in metadata
  const metadataAvatar =
    (user.user_metadata?.avatar_url as string | undefined) ||
    (user.user_metadata?.picture as string | undefined) ||
    (profile as any)?.avatar_url ||
    null;

  if (metadataAvatar) return metadataAvatar;

  // Fallback to a generated avatar based on the user's display name
  const displayName = getUserDisplayName(user, profile ?? null);
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=0EA5E9&color=fff&size=128`;
}

